/* eslint-disable @typescript-eslint/naming-convention */
import { ModelValidationMetadataMap } from 'app/core/validation';

export const customPropertyValidationMetadata: ModelValidationMetadataMap = {
  CustomProperty: {
    properties: {
      customPropertyTypeId: {
        required: true,
        displayName: 'Custom Property Type',
      },
      dateFrom: {
        required: true,
        displayName: 'Date From',
      },
      dateTo: {
        required: true,
        displayName: 'Date To'
      },
      propertyValue: {
        required: false,
        displayName: 'Comment'
      },
      value: {
        required: true,
        displayName: 'Approved'
      },
      value1: {
        required: false,
        displayName: 'Requested'
      },
      notes: {
        maxLength: 2000,
        displayName: 'Notes'
      }
    }
  }
};
